import axios from 'axios';
import config from '@/config';
import moment from 'moment';

export default {
  namespaced: true,
  state: {
    license: {},
    error: null,
    warning: null,
    licenseWarning: null,
    hasError: false,
    hasWarning: false,
    loading: false
  },
  mutations: {
    SET_LICENSE(state, payload) {
      state.license = payload;
    },
    SET_ERROR(state, payload) {
      state.error = payload;
    },
    SET_HAS_ERROR(state, payload) {
      state.hasError = payload;
    },
    SET_WARNING(state, payload) {
      state.warning = payload;
    },
    SET_LICENSE_WARNING(state, payload) {
      state.licenseWarning = payload;
    },
    SET_HAS_WARNING(state, payload) {
      state.hasWarning = payload;
    },
    SET_LOADING(state, payload) {
      state.loading = payload;
    }
  },
  actions: {
    async getLicense({ commit }) {
      if (process.env.NODE_ENV === 'development') return;

      commit('SET_ERROR', null);
      commit('SET_WARNING', null);
      commit('SET_LICENSE_WARNING', null);
      commit('SET_HAS_WARNING', false);
      commit('SET_HAS_ERROR', false);
      try {
        const {
          data: { success, data, message, warning }
        } = await axios.get(`${config.server_url}/api/license`);

        if (success) {
          commit('SET_LICENSE', data);

          if (warning && warning.message) {
            commit('SET_LICENSE_WARNING', warning);
            commit('SET_HAS_WARNING', true);

            let warningMessages = [];
            if (warning.localLicense && warning.localLicense.warning) {
              warningMessages.push(
                `Local license will expire in ${warning.localLicense.daysLeft} day(s)`
              );
            }
            if (warning.onlineLicense && warning.onlineLicense.warning) {
              warningMessages.push(
                `Online license will expire in ${warning.onlineLicense.daysLeft} day(s)`
              );
            }

            if (warningMessages.length > 0) {
              commit('SET_WARNING', warningMessages.join('. ') + '.');
            }
          } else {
            const now = moment().add(1, 'M');
            const expiration = moment(data.expires);
            if (now.isAfter(expiration) && data.period !== 0) {
              commit('SET_HAS_WARNING', true);
              commit('SET_WARNING', `Your license will expire in ${data.daysLeft} days.`);
            }
          }
        } else {
          commit('SET_LICENSE', {});
          commit('SET_ERROR', message);
          commit('SET_HAS_ERROR', true);
        }
      } catch (e) {
        commit('SET_ERROR', 'Unknown license error.');
        commit('SET_HAS_ERROR', true);
      }
    },
    async uploadLicense({ commit, dispatch }, payload) {
      try {
        const formData = new FormData();
        formData.append('license', payload);
        const {
          data: { success, message }
        } = await require('axios').post(`${config.server_url}/api/upload-license`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });

        if (success) {
          await dispatch('getLicense');
        } else {
          throw message;
        }
      } catch (err) {
        throw err;
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/license.js